import { Link } from 'react-router-dom';
import { Button } from '@vnetwork/ui/primitives';
import { EmptyState } from '@vnetwork/ui/data';

export default function NotFoundPage() {
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
      <EmptyState
        title="Page not found"
        description="The page you’re looking for doesn’t exist or has moved."
        actions={
          <Button asChild variant="primary">
            <Link to="/">Back to overview</Link>
          </Button>
        }
      />
    </div>
  );
}
